import React, { createContext, useContext, PropsWithChildren } from 'react';
import { observer } from 'mobx-react-lite';
import {
    useIntegratedAdditionalInfosStore,
    UseAdditionalInfosParams,
} from './use-additional-infos';

export const AdditionalInfosContext = createContext<
    ReturnType<typeof useIntegratedAdditionalInfosStore> | undefined
>(undefined);

export const useAdditionalInfos = (): ReturnType<typeof useIntegratedAdditionalInfosStore> => {
    const store = useContext(AdditionalInfosContext);
    if (!store) throw new Error("Couldn't find AdditionalInfosContext");
    return store;
};

/**
 * Single provider for additional-infos state. Replaces the former two-layer
 * `AdditionalInfosProvider` -> `AdditionalInfosProviderCore` indirection.
 *
 * All props are explicit — no implicit context chains.
 */
export const AdditionalInfosStoreProvider: React.FC<
    PropsWithChildren<UseAdditionalInfosParams>
> = observer(({ children, ...rest }) => {
    const store = useIntegratedAdditionalInfosStore(rest);
    return (
        <AdditionalInfosContext.Provider value={store}>{children}</AdditionalInfosContext.Provider>
    );
});
